<template>
  <div>
    <h4>
      <span :class="classes">
        {{ parameters.text }}
      </span>
    </h4>
  </div>
</template>
<script>
export default {
  name: 'sheet-add-preview-title',
  props: {
    parameters: {
      type: Object,
      required: true
    }
  },

  computed: {
    classes: function () {
      if (this.parameters.type == null) {
        return 'label label-warning'
      }

      const shortcuts = {
        title: 'warning',
        subtitle: 'default',
        'subtitle-alt': 'alt',
        'subtitle-sub': 'sub',
        'observation': 'obs',
        'observation-subtitle': 'obs-sub',
        'observation-question': 'obs-qcm'
      }

      let type = shortcuts[this.parameters.type]
      type = type == null ? this.parameters.type : type
      return `label label-${type}`
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';
@import '~modules';

.label {
    display: block;
    text-align: left;
}

.label-alt {
    background-color: darken(@gray-lighter, 25%);
}

.label-title-alt {
    background-color: lighten(@brand-danger, 15%);
}

.label-sub {
    background-color: @brand-primary;
}

.label-obs {
  background-color: lighten(#002060, 15%);
}

.label-obs-sub {
  background-color: lighten(#4f81bd, 5%);
}

.label-obs-qcm {
  background-color: darken(#e18f2d, 20%);
}

.label-results {
  &:extend(.bg-results);
}
</style>
